import React from 'react';
import styled from 'styled-components';
import { isFieldValid } from '../../utils/validation';
import { PlayButton } from '../Buttons';
import { Image } from '../Image';
const ImageContainer = styled.div `
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
const ButtonPosition = styled.div `
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
export const VideoThumbnail = ({ media, onPlay, isNotTabbable }) => {
    if (!media) {
        return null;
    }
    return (React.createElement(ImageContainer, null,
        isFieldValid(media) && React.createElement(Image, { media: media }),
        React.createElement(ButtonPosition, null,
            React.createElement(PlayButton, { onClick: onPlay, size: 70, isNotTabbable: isNotTabbable }))));
};
